<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="users-table-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <div class="page-navigation-container d-flex flex-column flex-grow-1">
        <UsersSearchForm />
      </div>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Users Page Content -->
    <v-content>
      <v-toolbar class="flex-column pa-2" style="height: auto; min-height: 80px;">
        <div class="d-flex flex-wrap align-center w-100 mt-5">
          <v-app-bar-nav-icon
            class="page-drawer-toggle mr-0"
            @click="isDrawerOpen = !isDrawerOpen">
          </v-app-bar-nav-icon>

          <v-toolbar-title
            class="pl-0">
            <MainNavigationMenu />
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Page Filter -->
          <div class="d-flex"
              :class="isMobile ? 'w-100' : ''">
            <div
                class="page-filter d-sm-block mr-5"
                :class="isMobile ? 'flex-grow-1' : ''"
                v-if="isPermittedAll([
                'UsersGetAll'
                ])">
                <v-text-field
                prepend-inner-icon="mdi-magnify"
                clearable
                outlined
                filled
                hide-details
                v-model="usersFilter"
                placeholder="Filter users">
                </v-text-field>
            </div>
            <!-- / Page Filter -->

            <!-- Add New -->
            <v-btn
                v-if="isPermittedAll([
                'UsersCreate'
                ])"
                class="toolbar-btn"
                color="primary"
                @click="openNewUser">
                <v-icon size="13">mdi-plus</v-icon>
                <span class="d-none d-sm-inline">Add New</span>
            </v-btn>
            <!-- / Add New -->
            </div>
         </div>
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- Users Table -->
      <UsersTable
        class="page-content mx-sm-5 mb-sm-5 mt-3"
        :users="users"
      />
      <!-- / Users Table -->
    </v-content>
    <!-- / Users Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import UserMenu from '../components/UserMenu.vue';
import UsersSearchForm from '../components/UsersSearchForm.vue';
import UsersTable from '../components/UsersTable.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import PosmLogo from '../components/PosmLogo.vue';

export default {
  name: 'UsersTablePage',
  components: {
    UserMenu,
    UsersSearchForm,
    UsersTable,
    MainNavigationMenu,
    PosmLogo,
  },
  data() {
    return {
      usersFilter: '',
    };
  },
  computed: {
    users() {
      const search = (this.usersFilter || '').toLowerCase();

      return _.filter(
        this.$store.state.users,
        (user) => !search
          || user.UserGivenName.toLowerCase().includes(search)
          || user.UserLocation.toLowerCase().includes(search)
          || user.UserPhoneNumber.toLowerCase().includes(search)
          || user.UserEmailAddress.toLowerCase().includes(search)
          || user.UserNotes.toLowerCase().includes(search),
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    openNewUser() {
      this.$store.commit('setActiveUser');
      this.$router.push({ name: 'UserFormNewPage' });
    },
  },
};
</script>

<style lang="scss"></style>
